class ForecastDayModel {
  constructor(properties) {
    this.date = properties.date;
    this.forecasts = properties.forecasts;
    this.spraying = properties.spraying;
    this.predictedEvapotranspiration = properties.predictedEvapotranspiration;
  }
}
export default ForecastDayModel;
